import { render } from "./WCPaymentOptionBadges.vue?vue&type=template&id=50496744&scoped=true"
import script from "./WCPaymentOptionBadges.vue?vue&type=script&lang=js"
export * from "./WCPaymentOptionBadges.vue?vue&type=script&lang=js"

import "./WCPaymentOptionBadges.vue?vue&type=style&index=0&id=50496744&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50496744"]])

export default __exports__